export const DonationType = {
  LINKED_DONATION: 'linked',
  UNLINED_DONATION: 'unlinked'
}

export const DonationCategory = {
  PICKUP: 'PICKUP',
  DROPOFF: 'DROPOFF'
}

// Mirrors firebase/functions/src/integrations/constants.js IntegrationType.
export const IntegrationType = {
  SHIPDAY: 'shipday'
}